//
// Module for a Generate Schedules wizard dates step
//
rs.module("jobs/criteria/generateschedules/datesstep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, grid) {

            var stepContainer = $.js(jsSelectors.stepContainer);

            var addDueDateLink = stepContainer.js(jsSelectors.addDueDateLink);

            // Hook up a grid's Add link click
            addDueDateLink.click(function () {
                grid.addRow();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);